/* tslint:disable */
import {
  PatientNotificationChain,
  PatientNotification
} from '../index';

declare var Object: any;
export interface PatientChainNotificationsMappingInterface {
  "id"?: any;
  "chainId"?: any;
  "notificationId"?: any;
  chain?: PatientNotificationChain;
  notification?: PatientNotification;
}

export class PatientChainNotificationsMapping implements PatientChainNotificationsMappingInterface {
  "id": any;
  "chainId": any;
  "notificationId": any;
  chain: PatientNotificationChain;
  notification: PatientNotification;
  constructor(data?: PatientChainNotificationsMappingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PatientChainNotificationsMapping`.
   */
  public static getModelName() {
    return "PatientChainNotificationsMapping";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PatientChainNotificationsMapping for dynamic purposes.
  **/
  public static factory(data: PatientChainNotificationsMappingInterface): PatientChainNotificationsMapping{
    return new PatientChainNotificationsMapping(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PatientChainNotificationsMapping',
      plural: 'PatientChainNotificationsMappings',
      path: 'PatientChainNotificationsMappings',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "chainId": {
          name: 'chainId',
          type: 'any'
        },
        "notificationId": {
          name: 'notificationId',
          type: 'any'
        },
      },
      relations: {
        chain: {
          name: 'chain',
          type: 'PatientNotificationChain',
          model: 'PatientNotificationChain',
          relationType: 'belongsTo',
                  keyFrom: 'chainId',
          keyTo: 'id'
        },
        notification: {
          name: 'notification',
          type: 'PatientNotification',
          model: 'PatientNotification',
          relationType: 'belongsTo',
                  keyFrom: 'notificationId',
          keyTo: 'id'
        },
      }
    }
  }
}
